import { Component, Host, h, Prop, Element } from '@stencil/core';
import { GAM_FLAG } from '../../../constant/components/cmsGamBanner';
@Component({
  tag: 'cms-gam-banner',
  styleUrl: 'cms-gam-banner.scss',
  shadow: false,
})
export class CmsGamBanner {
  /**
   * Whether this banner is gam banner
   */
  @Prop() dataGamFlag: string = GAM_FLAG.DISABLED;

  /**
   * Campaign Id
   */
  @Prop() dataCampaignId: number = 0;

  /**
   * Slot Id
   */
  @Prop() dataBannerId: number = 0;

  /**
   * Gam Ad Unit Path
   */
  @Prop() dataAdUnitPath: string = '';

  /**
   * Language Code
   */
  @Prop() dataLanguage: string = '';

  /**
   * Country Code
   */
  @Prop() dataCountry: string = '';

  /**
   * Platform
   */
  @Prop() dataPlatform: number = null;

  /**
   * Slot Order
   */
  @Prop() dataSlotOrder: number = null;

  /**
   * Category Id
   */
  @Prop() dataCategoryId: number = null;
  @Element() elRoot: HTMLElement;
  private id: string = `div-cms-gam-banner-${this.dataCampaignId}-${this.dataBannerId}`;

  private isGam = () => {
    return this.dataGamFlag === GAM_FLAG.ENABLED;
  };

  connectedCallback() {
    this.elRoot.innerHTML = '';
    if (!this.isGam()) {
      this.elRoot.remove();
    } else {
      this.buildGamScriptEntry();
    }
  }

  componentDidLoad() {
    if (this.isGam()) {
      this.appendScriptToHead();
      this.appendScriptToDiv();
    }
  }

  private buildGamScriptEntry = () => {
    const scriptGamEntry = document.createElement('script');
    scriptGamEntry.async = true;
    scriptGamEntry.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
    if (document.querySelector(`script[src="${scriptGamEntry.src}"]`)) {
      return;
    }
    document.head.appendChild(scriptGamEntry);
  };

  private appendScriptToHead = () => {
    const script: HTMLScriptElement = document.createElement('script');
    script.type = 'text/javascript';
    script.id = `script-for-${this.id}`;
    const setTargetingLanguage: string = !!this.dataLanguage
      ? `.setTargeting('language', ['${this.dataLanguage}'])`
      : '';
    const setTargetingPlatform: string =
      this.dataPlatform !== null ? `.setTargeting('platform', ['${this.dataPlatform}'])` : '';
    const setCampaignId = !!this.dataCampaignId ? `.setTargeting('campaignId', ['${this.dataCampaignId}'])` : '';
    const setBannerId = !!this.dataBannerId ? `.setTargeting('bannerId', ['${this.dataBannerId}'])` : '';
    const jsContent = `
    window.googletag = window.googletag || {cmd: []};
        googletag.cmd.push(function() {
            googletag
                .defineSlot(
                    '${this.dataAdUnitPath}', ["fluid"], '${this.id}')
                ${setTargetingLanguage}
                ${setCampaignId}
                ${setTargetingPlatform}
                ${setBannerId}
                .addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.enableServices();

            googletag.pubads().addEventListener("slotRenderEnded", (event) => {
               try {
                document.querySelector('cms-gam-banner[data-campaign-id="${this.dataCampaignId}"][data-banner-id="${this.dataBannerId}"]').setAttribute('style', 'z-index: 1');
               } catch (e) {
               }
            })
        });
    `;
    if (document.querySelector(`script[id="script-for-${this.id}"]`)) {
      return;
    }
    script.appendChild(document.createTextNode(jsContent));
    document.head.appendChild(script);
  };

  private appendScriptToDiv = () => {
    const script: HTMLScriptElement = document.createElement('script');
    script.type = 'text/javascript';
    const jsContent: string = `
    googletag.cmd.push(function () {
        googletag.display("${this.id}");
      });
`;
    script.appendChild(document.createTextNode(jsContent));
    this.elRoot.appendChild(script);
  };

  render() {
    return <Host id={this.id} />;
  }
}
